export default "__VITE_ASSET__aa5d0778__"